var DialogView = require('dialogview');


var ConnectionTokenView = DialogView.extend({
    el: '.connToken',
    initialize: function (options) {
        this.revealed = false;

        this.error = this.$('.connToken__error');

        this.title = this.$('.connToken__title');
        this.token = this.$('.connToken__token');
        this.tokenPresent = this.$('.connToken__token-present');
        this.input = this.$('.connToken__input');
        this.inputContainer = this.$('.connToken__details-input');
        this.reveal = this.$('.connToken__reveal');
        this.netName = this.$('.connToken__netname');
        this.host = this.$('.connToken__host');
        this.disallowed = this.$('.connToken__disallowed');
        this.generateForm = this.$('.connToken__generate-form');

        this.tokenPrompts = this.$('.connToken__generate-prompts');
        this.regeneratePrompt = this.$('.connToken__regenerate-prompt');

        this.revokeForm = this.$('.connToken__revoke-form');
        this.regenerateForm = this.$('.connToken__regenerate-form');

        this.removeToken();
        this.generateForm.hide();

        this.afterHide = _.bind(function () {
            this.cancelAjax();

            this.connection = null;
            
            this.error.hide();

            this.netName.empty();
            this.host.empty();

            this.removeToken();
            this.generateForm.hide();
        }, this);
        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit form.connToken__generate-form': 'submitGenerate',
        'submit form.connToken__regenerate-form': 'submitGenerate',
        'buttonClick .connToken__revoke-prompt': 'promptRevoke',
        'buttonClick .connToken__reveal': 'clickRevealPass',
        'buttonClick .connToken__revoke-cancel': 'cancelRevoke',
        'buttonClick .connToken__regenerate-prompt': 'promptRegenerate',
        'buttonClick .connToken__regenerate-cancel': 'cancelRegenerate',
        'submit form.connToken__revoke-form': 'submitRevoke',
        'focus .connToken__input': 'selectInput'
    }),
    selectInput: function (e) {
        // https://stackoverflow.com/a/22102081/115076
        this.input.one('mouseup.mouseupSelect', _.bind(function() {
            this.input.select();
            return false;
        }, this));
        this.input.one('mousedown', _.bind(function() {
            // compensate for untriggered 'mouseup' caused by focus via tab
            this.input.off('mouseup.mouseupSelect');
        }, this));
        this.input.select();
    },
    clickRevealPass: function (e) {
        this.revealed = !this.revealed;
        this.renderRevealPass();
    },
    renderRevealPass: function () {
        this.$el.toggleClass('connToken--reveal', this.revealed);
    },
    removeToken: function () {
        this.token.hide();
        this.tokenPresent.hide();
        this.input.val('');
        this.input.prop('disabled', true);
        this.showGenerateForm();
        this.tokenPrompts.hide();
        this.revokeForm.hide();
        this.regenerateForm.hide();
        this.revealed = false;
        this.renderRevealPass();
    },
    showGenerateForm: function () {
        this.generateForm.toggle(this.model.isBncAllowed());
    },
    setConnDetails: function (isSlack) {
        var subdomain = isSlack ? 'slack' : 'bnc';
        var host = subdomain + '.irccloud.com';
        var port = 6697;
        var link = 'ircs://' + host + ':' + port;
        this.$('.connToken__details-link').attr('href', link).text(link);
        this.$('.connToken__details-host').text(host);
        this.$('.connToken__details-port').text(port);
        this.$('.connToken__details-revoke-text').toggle(!isSlack);
        this.$('.connToken__details-history').toggle(!isSlack);
    },
    showToken: function (token, isSlack) {
        this.input.val(token);
        this.setConnDetails(isSlack);
        this.input.prop('disabled', false);
        this.token.toggle(this.model.isBncAllowed());
        this.tokenPresent.toggle(!this.model.isBncAllowed());
        this.revokeForm.hide();
        this.regenerateForm.hide();
        this.generateForm.hide();
        this.regeneratePrompt.toggle(this.model.isBncAllowed());
        this.tokenPrompts.toggle(!isSlack);
    },
    submitGenerate: function (e) {
        e.preventDefault();
        this.connection.post("generate-connection-token", {
            cid: this.connection.id
        }, _.bind(function (response) {
            if (response.success) {
                this.showToken(response.token, false);
                var regen = $(e.target).is(this.regenerateForm);
                var success = 'Password ' + (regen ? 're' : '') + 'generated';
                this.input.highlightFlash(200);
            } else {
                var error;
                switch (response.message) {
                case 'bnc_disallowed':
                    error = 'Connecting with another client <a href="/?/upgrade">requires a subscription</a>';
                    break;
                default:
                    error = 'There was a problem generating a password';
                }
                this.showError(error);
            }
        }, this));
    },
    promptRevoke: function (e) {
        e.preventDefault();
        this.regenerateForm.hide();
        this.revokeForm.show();
    },
    cancelRevoke: function (e) {
        e.preventDefault();
        this.revokeForm.hide();
    },
    promptRegenerate: function (e) {
        e.preventDefault();
        this.revokeForm.hide();
        if (this.model.isBncAllowed()) {
            this.regenerateForm.show();
        }
    },
    cancelRegenerate: function (e) {
        e.preventDefault();
        this.regenerateForm.hide();
    },
    submitRevoke: function (e) {
        e.preventDefault();
        this.connection.post("revoke-connection-token", {
            cid: this.connection.id
        }, _.bind(function (response) {
            if (response.success) {
                this.removeToken();
            } else {
                var message = 'There was a problem revoking the password';
                this.showError(message);
            }
        }, this));
    },
    showError: function (message) {
        this.error.html(message).fadeIn('fast');
    },
    cancelAjax: function () {
        if (this.ajax) {
            this.ajax.cancel();
            this.ajax = null;
        }
    },
    show: function (connection) {
        this.title.addSpin();

        this.connection = connection;
        this.netName.text(this.connection.getName());
        var hostname = this.connection.isSlack() ? 'Slack' : this.connection.getHost();
        this.host.text(hostname);

        this.disallowed.toggle(!this.model.isBncAllowed());

        this.cancelAjax();
        var ajax = this.model.backend.get('get-connection-token', {
            cid: this.connection.id
        }, _.bind(function (response) {
            if (this.ajax === ajax) {
                this.title.removeSpin();
                if (response.error || response.success === false) {
                    if (response.message == 'not_found') {
                        this.showGenerateForm();
                    } else {
                        var message = 'There was a problem checking this connection, try again later';
                        this.showError(message);
                    }
                } else {
                    this.showToken(response.token, response.is_slack);
                }
            }
            this.ajax = null;
        }, this));
        this.ajax = ajax;
        DialogView.prototype.show.call(this);
    }
});


module.exports = ConnectionTokenView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/connectiontokenview.js
// module id = a2Rs
// module chunks = 1